import { capitalize } from "lodash";
import { z } from "zod";

import { DataExportV2PeriodType } from "@north-beam/nb-client-side/nb-api-graphql-generated";
import {
  dynamicPeriodTypes,
  type DynamicPeriodType,
} from "@north-beam/nb-common";

const getPeriodTypeLabel = (type: DynamicPeriodType) => {
  const words = type.split("_");
  const lowercaseWords = ["AND", "TO"];
  const wordsCapitalized = words.map((word) =>
    lowercaseWords.includes(word) ? word.toLowerCase() : capitalize(word),
  );

  const periodTypeLabel = wordsCapitalized.join(" ");
  return periodTypeLabel;
};

export const dynamicPeriodTypesOptions = dynamicPeriodTypes.map((type) => ({
  value: type,
  label: getPeriodTypeLabel(type),
}));

export const dynamicPeriodSchema = z.object({
  type: z.nativeEnum(DataExportV2PeriodType),
});

export const periodSchema = z.discriminatedUnion("type", [dynamicPeriodSchema]);
